import React from 'react';
import PdfTest from '../components/PdfTest';

const PdfTestPage: React.FC = () => {
  return (
    <div className="container mx-auto p-6">
      <h1 className="text-2xl font-bold mb-6">PDF Font Testing</h1>
      <div className="max-w-md">
        <PdfTest />
      </div>
    </div>
  );
};

export default PdfTestPage;
